module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('bold')
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale["bold"]))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('italic')
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale["italic"]))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('underline')
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale["underline"]))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('strikeThrough')
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale["strike through"]))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('subscript')
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale["subscript"]))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('superscript')
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale["superscript"]))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-67f1e1fa!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/modules/text/dashboard.vue
// module id = 660
// module chunks = 0